import * as THREE from 'three';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';

const orbitalMeshes = [];

const canvas = document.querySelector('canvas.webgl');
const scene = new THREE.Scene();

const textureLoader = new THREE.TextureLoader();
const matcapTexture = textureLoader.load('textures/matcaps/alex_brotman.png');
matcapTexture.colorSpace = THREE.SRGBColorSpace;

const fontLoader = new FontLoader();

fontLoader.load(
    '/fonts/Anta-Regular.json',
    (font) =>
    {
        const material = new THREE.MeshMatcapMaterial({ matcap: matcapTexture });
        const textGeometry = new TextGeometry(
            'Alex Brotman',
            {
                font: font,
                size: 0.5,
                depth: 0.02,
                curveSegments: 12,
                bevelEnabled: true,
                bevelThickness: 0.03,
                bevelSize: 0.02,
                bevelOffset: 0,
                bevelSegments: 5
            }
        );
        textGeometry.center();

        const text = new THREE.Mesh(textGeometry, material);
        scene.add(text);

        const donutGeometry = new THREE.TorusGeometry(0.3, 0.2, 32, 64);
        const sphereGeometry = new THREE.SphereGeometry(0.3, 32, 32);
        const boxGeometry = new THREE.BoxGeometry(0.4, 0.4, 0.4);

        for(let i = 0; i < 100; i++)
        {
            const randomSelection = Math.floor(Math.random() * 3);
            let selectedShape;
            if(randomSelection === 0) 
                selectedShape = donutGeometry
            else if(randomSelection === 1) 
                selectedShape = sphereGeometry
            else
                selectedShape =boxGeometry
            const shape = new THREE.Mesh(selectedShape, material);
            const radius = 2.5 + Math.random() * 6.5;
            const speed = 0.05 + Math.random() * 0.2;
            const phase = Math.random() * Math.PI * 2;
            const axis = new THREE.Vector3(Math.random()-0.5, Math.random()-0.5, Math.random()-0.5).normalize();
            let base;
            do {
                base = new THREE.Vector3(Math.random()-0.5, Math.random()-0.5, Math.random()-0.5).normalize();
            } while (Math.abs(base.dot(axis)) > 0.95);
            shape.position.set(0,0,0);
            shape.rotation.x = Math.random() * Math.PI;
            shape.rotation.y = Math.random() * Math.PI;
            const scale = Math.random();
            shape.scale.set(scale, scale, scale);
            orbitalMeshes.push({ mesh: shape, axis, speed, radius, phase, base });
            scene.add(shape);
        }
    }
)

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
};

window.addEventListener('resize', () =>
{
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
});

const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100);
camera.position.x = 0;
camera.position.y = 0;
camera.position.z = 12;
scene.add(camera);

const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

const clock = new THREE.Clock();

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime();

    for (const obj of orbitalMeshes) {
        const angle = obj.phase + elapsedTime * obj.speed;
        const pos = obj.base.clone().multiplyScalar(obj.radius);
        pos.applyAxisAngle(obj.axis, angle);
        obj.mesh.position.set(pos.x, pos.y, pos.z);
        obj.mesh.rotation.x += 0.005;
        obj.mesh.rotation.y += 0.005;
    }

    renderer.render(scene, camera);

    window.requestAnimationFrame(tick);
}

tick();